import Vue from 'vue';
import { MutationTree } from 'vuex';
import { StudyPlanningState } from './state';
import { StudyPlanningInfo } from '@/models/studyPlanning/StudyPlanningModel';
import { WeekInfo } from '@/models/studyPlanning/WeekModel';
import { ListInfo } from '@/models/studyPlanning/ListModel';
import { StudyPlanningBreakpointInfo } from '@/models/studyPlanning/StudyPlanningBreakpointModel';

import { StudyPlanningChimeraContractInfo } from '@/models/studyPlanning/StudyPlanningContractModel';

const mutations: MutationTree<StudyPlanningState> = {
  SET_STUDY_PLANNING(state, studyPlanning: StudyPlanningInfo) {
    if (!studyPlanning) return;
    Vue.set(state, 'studyPlanning', studyPlanning);
  },
  SET_WEEK(state, currentWeek: WeekInfo | null) {
    Vue.set(state, 'currentWeek', currentWeek);
  },
  SET_WEEK_LISTS(state, weekLists: ListInfo[]) {
    Vue.set(state, 'weekLists', weekLists);
  },
  SET_ANTICIPATED_WEEKS(state, anticipatedWeeks: WeekInfo[]) {
    if (!anticipatedWeeks) return;

    anticipatedWeeks.forEach((w) =>
      Vue.set(state.anticipatedWeeks, w.id, { ...w, isAnticipated: true }),
    );
  },
  SET_ANTICIPATED_WEEKS_LISTS(state, anticipatedWeeks: Array<WeekInfo & { lists: ListInfo[] }>) {
    if (!anticipatedWeeks) return;

    anticipatedWeeks.forEach((w) =>
      Vue.set(state.anticipatedWeeksListsByWeekId, w.id, [
        ...w.lists.map((l) => ({ ...l, isAnticipated: true })),
      ]),
    );
  },
  SET_STUDY_PLANNING_BREAKPOINTS(state, breakpoints: StudyPlanningBreakpointInfo[]) {
    if (!breakpoints) return;

    state.breakpoints = {};
    breakpoints.forEach((breakpoint) =>
      Vue.set(state.breakpoints, breakpoint.numberOfMonths.toString(), {
        ...breakpoint,
      }),
    );
  },
  SET_STUDY_PLANNING_EXTENSION_BREAKPOINTS(
    state,
    extensionBreakpoints: StudyPlanningBreakpointInfo[],
  ) {
    if (!extensionBreakpoints) return;

    state.extensionBreakpoints = {};
    extensionBreakpoints.forEach((breakpoint) =>
      Vue.set(state.extensionBreakpoints, breakpoint.numberOfMonths.toString(), {
        ...breakpoint,
      }),
    );
  },
  SET_CURRENT_CHIMERA_COURSE_CONTRACT_INFO(
    state,
    chimeraContract: StudyPlanningChimeraContractInfo,
  ) {
    if (!chimeraContract) return;
    Vue.set(state, 'chimeraContract', chimeraContract);
  },
};

export default mutations;
